import React, { Component } from 'react';
import './Tooltip.scss';

class Tooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showTooltip': false,
    };
  }

  render() {
    const { showTooltip } = this.state;
    const { tooltip, children } = this.props;

    return (
      <div className="tooltip-container">
        {children}
        <div className="fa-regular fa-circle-question"
          onMouseEnter={() => this.setState({ 'showTooltip': true })}
          onMouseLeave={() => this.setState({ 'showTooltip': false })} />
        {showTooltip && <div className="tooltips" >{tooltip}</div>}
      </div>
    );
  }
}

export default Tooltip;
